const FILE_ICONS: Record<string, string> = {
  pdf: 'ni-file-pdf',
  word: 'ni-file-doc',
  document: 'ni-file-doc',
  sheet: 'ni-file-xls',
  excel: 'ni-file-xls',
};

export const getFileIcon = (type: string): string => {
  const match = Object.entries(FILE_ICONS).find(([key]) => type.includes(key));
  return match ? match[1] : 'ni-file';
};
